/*
 * Copyright (c) 2025.
 * This code and its derivatives belong to BETICA LTD and may not be copied, reproduced, amended or used in any way without the permission of BETICA LTD
 * @author torrejonv
 *
 */

/**
 * @file chat-selector.js
 * @description Redux selectors for accessing chat state data
 */

import {createSelector} from "@reduxjs/toolkit";

/**
 * @function getChatSessionId
 * @description Selector that returns the chat session id data from state
 * @param {Object} state - Redux state
 * @returns {*} Selected state data
 */
export const getChatSessionId = createSelector(
  (state) => state.chat?.sessionId,
  (sessionId) => sessionId,
);
